import { Directive, OnChanges, Input, ElementRef } from "@angular/core";
import { UserPreferencesService } from "../service/user-preferences.service";

@Directive({
    selector: '[appIconColor]'
  })
  export class IconColorDirective implements OnChanges {
  
    @Input() appIconColor: string;
  
    constructor(private el: ElementRef, private userPreferencesService: UserPreferencesService) {}
  
    ngOnChanges() {
      const color = (this.appIconColor === 'primary') ? this.userPreferencesService.getPrimaryColor() :
        this.userPreferencesService.getSecondaryColor();
      this.el.nativeElement.style.color = color;
    }
  }